/* eslint react/prefer-stateless-function: "off" */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Row } from 'react-bootstrap'
import { Col } from 'react-bootstrap'

import Clickable from '../../Clickable'
import PieChart from '../PieChart'
import RestrictableButton from '../../../../shared/components/Instructor/RestrictableButton'

import panelStyle from 'Styles/panel.css'
import style from './style.css'

export default class TopicPerformanceSummary extends Component {
  pieChartSlices () {
    let chartColor
    if (this.props.questionAccuracy < 70) {
      chartColor = '#DA1B2C' // --prs-c-red-500
    } else if (this.props.questionAccuracy >= 70 && this.props.questionAccuracy < 90) {
      chartColor = '#E5D676' // --prs-c-yellow-400
    } else { // percentage >= 90
      chartColor = '#68B75F' // --prs-c-green-400
    }
    return (
      [
        {
          color: '#fff',
          value: 100 - this.props.questionAccuracy
        },
        {
          color: chartColor,
          value: this.props.questionAccuracy
        }
      ]
    )
  }

  renderButton () {
    return (
      <Col xs={4} md={5} lg={5}>
        <p className={style.topicsLabel}>Topics:</p>
        <p className={style.topicCount}>{this.props.topicCount}</p>
        <div>
          <RestrictableButton
            id="topicsEditBtn"
            clickEventHandler={this.props.onEditTopicsClick}
            hidden={!this.props.showEditTopicsButton}
            tabIndex={0}
            dataTestId="topicsEditBtn"
            restricted={this.props.isRestrictedInstructor}
            buttonText="Edit Topics"
            ariaLabel="Edit Topics"
          />
        </div>
      </Col>
    )
  }

  renderShowAllStudents () {
    return (
      <Col xs={4} md={5} lg={5}>
        <Clickable
          className={style.showAllStudents}
          onClick={this.props.onShowAllStudents}
          tabIndex="0"
        >
          Show all students
        </Clickable>
      </Col>
    )
  }

  renderQuestionsAnswered () {
    return (
      <Col xs={4} sm={6} md={5} lg={5}>
        {this.props.mobile
          ? <div><span>Questions answered:</span>
            <h2 className={style.questionsAnswered}>{this.props.questionsReceived}</h2></div>
          : <div><h2 className={style.questionsAnswered}>{this.props.questionsReceived}</h2>
            <span>questions answered</span></div>}
      </Col>
    )
  }

  render () {
    const accuracyLabel = this.props.startedStudents === 0
      ? 'No activity <br /> data yet'
      : this.props.questionAccuracy + '% question <br /> accuracy'
    const selectedStudent = this.props.selectedStudent != null ? this.props.selectedStudent.name : 'All Students'
    return (
      <div
        tabIndex={this.props.mobile ? '1' : ''}
        className={classnames(panelStyle.large, style.panel)}
      >
        <Row>
          <Col >
            {this.props.mobile
              ? <p className={style.studyPlanHeader}>Topic Performance</p>
              : <p className={style.studyPlanHeader}>Topic Performance: {selectedStudent}</p>}
          </Col>
        </Row>
        <Row>

          {this.props.mobile
            ? this.renderQuestionsAnswered()
            : this.props.individualStudentSelected ? this.renderShowAllStudents() : this.renderButton()
          }

          <Col xs={4} sm={4} md={3} lg={3} className={style.smallGutterPie}>
            <div className={style.pieChartCol}>
              <PieChart
                slices={this.pieChartSlices()}
                borderColor={'#C8C8C8'} // --prs-c-gray-400
              />
            </div>
            {this.props.browser.lessThan.medium
              ? <div
                className={style.accuracyText}
                dangerouslySetInnerHTML={{ __html: accuracyLabel }}
              />
              : null}
          </Col>
          {!this.props.browser.lessThan.medium
            ? <Col
              xs={4}
              sm={4}
              md={4}
              lg={4}
              className={style.accuracyText}
              dangerouslySetInnerHTML={{ __html: accuracyLabel }}
            />
            : null}
        </Row>
      </div>
    )
  }
}

TopicPerformanceSummary.propTypes = {
  topicCount: PropTypes.number.isRequired,
  onEditTopicsClick: PropTypes.func.isRequired,
  questionAccuracy: PropTypes.number.isRequired,
  startedStudents: PropTypes.number,
  individualStudentSelected: PropTypes.bool.isRequired,
  onShowAllStudents: PropTypes.func.isRequired,
  mobile: PropTypes.bool,
  questionsReceived: PropTypes.number,
  selectedStudent: PropTypes.object,
  showEditTopicsButton: PropTypes.bool,
  browser: PropTypes.object.isRequired,
  isRestrictedInstructor: PropTypes.bool
}
